const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  903: {
    path: "/goods",
    name: "goods",
    meta: {
      title: "商品库",
      authId: "903",
      parentId: "1",
      cache: false
    }
  },
  // 90301: {
  //   path: "/product",
  //   name: "product",
  //   meta: {
  //     title: "素材管理",
  //     authId: "90301",
  //     parentId: "903",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9030101",
  //       parentId: "90301",
  //       label: "新增素材",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleAdd",
  //       addRoutePath: [
  //         {
  //           authId: "90304",
  //           name: "素材编辑",
  //           parentId: "90301"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9030103",
  //       parentId: "90301",
  //       label: "导出",
  //       category: "Button",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9030102",
  //       parentId: "90301",
  //       label: "修改",
  //       handle: "handleEdit",
  //       addRoutePath: [
  //         {
  //           authId: "90304",
  //           name: "素材编辑",
  //           parentId: "90301"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9030104",
  //       parentId: "90301",
  //       label: "删除",
  //       handle: "handleUpOrDown",
  //       ruleObj: {
  //         attr: "status",
  //         rule: {
  //           0: "使用",
  //           1: "删除"
  //         }
  //       }
  //     }
  //   ],
  //   component: _import("goods/product")
  // },
  // 90302: {
  //   path: "/commodity",
  //   name: "commodity",
  //   meta: {
  //     title: "商品管理",
  //     authId: "90302",
  //     parentId: "903",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9030201",
  //       parentId: "90302",
  //       label: "新增商品",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleAdd",
  //       addRoutePath: [
  //         {
  //           authId: "90305",
  //           name: "商品编辑",
  //           parentId: "90302"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9030202",
  //       parentId: "90302",
  //       label: "导出",
  //       category: "Button",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9030203",
  //       parentId: "90302",
  //       label: "编辑",
  //       handle: "handleEdit",
  //       addRoutePath: [
  //         {
  //           authId: "90305",
  //           name: "商品编辑",
  //           parentId: "90302"
  //         }
  //       ]
  //       // judgeShow: true
  //     },
  //     {
  //       authId: "9030205",
  //       parentId: "90302",
  //       label: "上架",
  //       handle: "handleUpOrDown",
  //       // judgeShow: true,
  //       ruleObj: {
  //         attr: "status",
  //         rule: {
  //           0: "上架",
  //           1: "下架"
  //         }
  //       }
  //     },
  //     {
  //       authId: "9030206",
  //       parentId: "90302",
  //       label: "删除",
  //       // judgeShow: true,
  //       handle: "handleDelete"
  //     },
  //     {
  //       authId: "9030207",
  //       parentId: "90302",
  //       label: "审核",
  //       category: "Button",
  //       handle: "handleExamine"
  //     },
  //     {
  //       authId: "9030208",
  //       parentId: "90302",
  //       label: "单独上架",
  //       handle: "handleUpOrDownForChild",
  //       // judgeShow: true,
  //       ruleObj: {
  //         attr: "status",
  //         rule: {
  //           0: "单独上架",
  //           1: "单独下架"
  //         }
  //       }
  //     },
  //     {
  //       authId: "9030209",
  //       parentId: "90302",
  //       label: "商品别名设置",
  //       handle: "handleSettingShopAlias"
  //     }
  //   ],
  //   component: _import("goods/commodity")
  // },
  // 90304: {
  //   path: "/editProduct",
  //   name: "editProduct",
  //   meta: {
  //     title: "素材编辑",
  //     authId: "90304",
  //     parentId: "90301",
  //     cache: false,
  //     sideHidden: true,
  //     activePath: "/product"
  //   },
  //   component: _import("goods/editProduct")
  // },

  // 90305: {
  //   path: "/editCommodity",
  //   name: "editCommodity",
  //   meta: {
  //     title: "商品编辑",
  //     authId: "90305",
  //     parentId: "90302",
  //     // cache: false,
  //     sideHidden: true,
  //     activePath: "/commodity"
  //   },
  //   component: _import("goods/editCommodity")
  // },
  90307: {
    path: "/productManage",
    name: "productManage",
    meta: {
      title: "产品管理",
      authId: "90307",
      parentId: "903",
      cache: false
    },
    auth: [
      {
        authId: "9030701",
        parentId: "90307",
        label: "新增产品",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "90308",
            name: "产品编辑",
            parentId: "90307"
          }
        ]
      },
      {
        authId: "9030702",
        parentId: "90307",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      },
      {
        authId: "9030703",
        parentId: "90307",
        label: "编辑",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "90308",
            name: "产品编辑",
            parentId: "90307"
          }
        ]
      },
      {
        authId: "9030706",
        parentId: "90307",
        label: "删除",
        handle: "handleDelete"
      },
      {
        authId: "9030707",
        parentId: "90307",
        label: "批量导入",
        category: "Button",
        type: "primary",
        handle: "handleBatchImport"
      },
      {
        authId: "9030708",
        parentId: "90307",
        label: "查看",
        handle: "handleCommodityDetail"
      }
    ],
    component: _import("goods/productManage/list")
  },
  90308: {
    path: "/editProductManage",
    name: "editProductManage",
    meta: {
      title: "产品编辑",
      authId: "90308",
      parentId: "90307",
      sideHidden: true,
      activePath: "/productManage"
    },
    component: _import("goods/productManage/update")
  },
  90309: {
    path: "/grounding",
    name: "grounding",
    meta: {
      title: "上架管理",
      authId: "90309",
      parentId: "903",
      cache: false
    },
    auth: [
      {
        authId: "9030901",
        parentId: "90309",
        label: "新增上架",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "90310",
            name: "上架编辑",
            parentId: "90309"
          }
        ]
      },
      {
        authId: "9030902",
        parentId: "90309",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      },
      {
        authId: "9030903",
        parentId: "90309",
        label: "批量审核",
        category: "Button",
        type: "primary",
        handle: "handleBatchReview"
      },
      {
        authId: "9030904",
        parentId: "90309",
        label: "删除",
        handle: "handleDel"
      },
      {
        authId: "9030905",
        parentId: "90309",
        label: "上架",
        handle: "handleUpOrDown",
        ruleObj: {
          attr: "status",
          rule: {
            0: "上架",
            1: "下架"
          }
        }
      },
      {
        authId: "9030906",
        parentId: "90309",
        label: "查看",
        handle: "handleView",
        addRoutePath: [
          {
            authId: "90311",
            name: "查看上架",
            parentId: "90309"
          }
        ]
      },
      {
        authId: "9030907",
        parentId: "90309",
        label: "编辑",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "90310",
            name: "上架编辑",
            parentId: "90309"
          }
        ]
      },
      {
        authId: "9030908",
        parentId: "90309",
        label: "批量下架",
        category: "Button",
        handle: "handleBatchOffShelf"
      },
      {
        authId: "9030909",
        parentId: "90309",
        label: "批量复制",
        category: "Button",
        handle: "handleBatchCopy"
      },
      {
        authId: "9030910",
        parentId: "90309",
        label: "批量校验最低价",
        category: "Button",
        type: "primary",
        handle: "handleBatchCheckPrice"
      },
      {
        authId: "9030911",
        parentId: "90309",
        label: "批量导入",
        category: "Button",
        type: "primary",
        handle: "handleBatchImport"
      }
    ],
    component: _import("goods/grounding/index")
  },
  90310: {
    path: "/editGrounding",
    name: "editGrounding",
    meta: {
      title: "上架编辑",
      authId: "90310",
      parentId: "90309",
      // cache: false,
      sideHidden: true,
      activePath: "/grounding"
    },
    component: _import("goods/grounding/editGrounding")
  },
  90311: {
    path: "/groundingDetail",
    name: "groundingDetail",
    meta: {
      title: "查看上架",
      authId: "90311",
      parentId: "90309",
      // cache: false,
      sideHidden: true,
      activePath: "/grounding"
    },
    auth: [
      {
        authId: "9031101",
        parentId: "90311",
        label: "审核",
        handle: "handleView"
      }
    ],
    component: _import("goods/grounding/groundingDetail")
  },
  90306: {
    path: "/coupons",
    name: "coupons",
    meta: {
      title: "发券宝",
      authId: "90306",
      parentId: "903",
      cache: false
    },
    auth: [
      {
        authId: "9030601",
        parentId: "90306",
        label: "新增",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9030604",
        parentId: "90306",
        label: "编辑",
        handle: "handleEdit"
      },
      {
        authId: "9030602",
        parentId: "90306",
        label: "停用",
        handle: "handleDisabled",
        ruleObj: {
          attr: "enabledFlag",
          rule: {
            Y: "停用",
            N: "启用"
          }
        }
      },
      {
        authId: "9030603",
        parentId: "90306",
        label: "删除",
        handle: "handleDelete"
      },
      {
        authId: "9030605",
        parentId: "90306",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      }
    ],
    component: _import("goods/coupons")
  },
  90312: {
    path: "/packageManage",
    name: "packageManage",
    meta: {
      title: "套餐管理",
      authId: "90312",
      parentId: "903",
      cache: false
    },
    auth: [
      {
        authId: "9031201",
        parentId: "90312",
        label: "新增套餐",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "9031202",
            name: "套餐编辑",
            parentId: "90312"
          }
        ]
      },
      {
        authId: "9031203",
        parentId: "90312",
        label: "编辑",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "9031202",
            name: "套餐编辑",
            parentId: "90312"
          }
        ]
      },
      {
        authId: "9031204",
        parentId: "90312",
        label: "查看",
        handle: "handleView",
        addRoutePath: [
          {
            authId: "9031205",
            name: "查看套餐",
            parentId: "90312"
          }
        ]
      },
      {
        authId: "9031206",
        parentId: "90312",
        label: "批量审核",
        category: "Button",
        type: "primary",
        handle: "handleBatchCheck"
      },
      {
        authId: "9031207",
        parentId: "90312",
        label: "删除",
        handle: "handleDel"
      },
      {
        authId: "9031208",
        parentId: "90312",
        label: "上架",
        handle: "handleUpOrDown",
        ruleObj: {
          attr: "status",
          rule: {
            0: "上架",
            1: "下架"
          }
        }
      },
      {
        authId: "9031210",
        parentId: "90312",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      }
    ],
    component: _import("goods/packageManage/index")
  },
  9031202: {
    path: "/editPackage",
    name: "editPackage",
    meta: {
      title: "套餐编辑",
      authId: "9031202",
      parentId: "90312",
      sideHidden: true,
      activePath: "/packageManage"
    },
    component: _import("goods/packageManage/editPackage")
  },
  9031205: {
    path: "/packageView",
    name: "packageView",
    meta: {
      title: "查看套餐",
      authId: "9031205",
      parentId: "90312",
      sideHidden: true,
      activePath: "/packageManage"
    },
    auth: [
      {
        authId: "9031209",
        parentId: "9031205",
        label: "审核",
        handle: "handleCheck"
      }
    ],
    component: _import("goods/packageManage/packageView")
  },
  90313: {
    path: "/shelfManage",
    name: "shelfManage",
    meta: {
      title: "嘀加上架",
      authId: "90313",
      parentId: "903",
      cache: false
    },
    auth: [
      {
        authId: "9031301",
        parentId: "90313",
        label: "嘀加上架与销售合同",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "9031302",
            name: "嘀加上架编辑",
            parentId: "90313"
          }
        ]
      },
      {
        authId: "9031303",
        parentId: "90313",
        label: "嘀加上架修改",
        category: "Button",
        type: "primary",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "9031302",
            name: "嘀加上架编辑",
            parentId: "90313"
          }
        ]
      },
      {
        authId: "9031304",
        parentId: "90313",
        label: "查看",
        handle: "handleContractDetail",
        addRoutePath: [
          {
            authId: "9031305",
            name: "运营确认",
            parentId: "90313"
          }
        ]
      },
      {
        authId: "9031306",
        parentId: "90313",
        label: "确认",
        handle: "handleEditContract",
        addRoutePath: [
          {
            authId: "9031307",
            name: "运营确认",
            parentId: "90313"
          }
        ]
      },
      {
        authId: "9031308",
        parentId: "90313",
        label: "驳回",
        handle: "handleReject"
      },
      {
        authId: "9031309",
        parentId: "90313",
        label: "重新发起",
        handle: "handleAgain",
        addRoutePath: [
          {
            authId: "9031302",
            name: "嘀加上架编辑",
            parentId: "90313"
          }
        ]
      }
    ],
    component: _import("goods/shelfManage/index")
  },
  9031302: {
    path: "/editShelf",
    name: "editShelf",
    meta: {
      title: "嘀加上架编辑",
      authId: "9031302",
      parentId: "90313",
      sideHidden: true,
      activePath: "/shelfManage"
    },
    component: _import("goods/shelfManage/editShelf")
  },
  9031305: {
    path: "/contractDetail",
    name: "contractDetail",
    meta: {
      title: "运营查看",
      authId: "9031305",
      parentId: "90313",
      sideHidden: true,
      activePath: "/shelfManage"
    },
    component: _import("goods/shelfManage/contractDetail")
  },
  9031307: {
    path: "/editContract",
    name: "editContract",
    meta: {
      title: "运营确认",
      authId: "9031307",
      parentId: "90313",
      sideHidden: true,
      activePath: "/shelfManage"
    },
    component: _import("goods/shelfManage/editContract")
  }
}
